"use strict";

var _classCallCheck = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/zacharialutz/projects/thinkful_EI/capstone-3/Group5-Capstone3-Client/node_modules/@babel/runtime/helpers/inherits");

var _require = require("../../utils"),
    mixin = _require.mixin;

var NodeImpl = require("./Node-impl").implementation;

var ChildNodeImpl = require("./ChildNode-impl").implementation;

var NODE_TYPE = require("../node-type");

var DocumentTypeImpl =
/*#__PURE__*/
function (_NodeImpl) {
  _inherits(DocumentTypeImpl, _NodeImpl);

  function DocumentTypeImpl(args, privateData) {
    var _this;

    _classCallCheck(this, DocumentTypeImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DocumentTypeImpl).call(this, args, privateData));
    _this.nodeType = NODE_TYPE.DOCUMENT_TYPE_NODE;
    _this.name = privateData.name;
    _this.publicId = privateData.publicId;
    _this.systemId = privateData.systemId;
    return _this;
  }

  return DocumentTypeImpl;
}(NodeImpl);

mixin(DocumentTypeImpl.prototype, ChildNodeImpl.prototype);
module.exports = {
  implementation: DocumentTypeImpl
};